import { render } from "./Toplogo.vue?vue&type=template&id=1a6787b5&scoped=true"
const script = {}

import "./Toplogo.vue?vue&type=style&index=0&id=1a6787b5&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6787b5"]])

export default __exports__